<template>
  <div class="month-select">
    <a-radio-group v-model="month" @change="onChange">
      <a-radio-button v-for="(item,index) in months" :key="index" :value="item">
        {{ item }}
      </a-radio-button>

    </a-radio-group>
  </div>
</template>
<script>

export default {
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      month: '',
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    }
  },
  watch: {
    month (newVal, oldVal) {
      this.$emit('input', newVal)
    },
    value (newVal, oldVal) {
      this.month = newVal
    }
  },
  mounted () {
    this.$nextTick(res => {
      // const date = new Date()
      // this.month = date.getMonth() + 1
      // this.month = this.month < 10 ? '0' + this.month : this.month + ''
    })
  },
  methods: {
    onChange () {}
  }
}
</script>
<style lang="less">
.tc{
  .ant-input{
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
@import '../../styles/var.less';

.ant-radio-group{
  width: 200px;
}
.ant-radio-button-wrapper{
  width: 42px;
  height: 26px;
  line-height: 26px;
  padding: 0 12px;
  border-radius: 2px;
  margin-top: 6px;
  margin-right: 6px;
  color: @text-color-lightgray;
  background-color: #f0f0f0;
  border: none;
  text-align: center;
}
.ant-radio-button-wrapper:not(:first-child)::before{
  background-color: @white !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  border-radius: 4px;
  background-color:@main-color;
  color: @white;
  box-shadow: none;
}
</style>
